import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { AdminPage } from "../features/admin/AdminPage";
import { ArchivePage } from "../features/archive/ArchivePage";
import { AuditPage } from "../features/audit/AuditPage";
import { DataQualityPage } from "../features/dataQuality/DataQualityPage";
import { DecksPage } from "../features/decks/DecksPage";
import { ImportPage } from "../features/import/ImportPage";
import { ProjectDetailPage } from "../features/projects/ProjectDetailPage";
import { ProjectsPage } from "../features/projects/ProjectsPage";
import { ProductsPage } from "../features/products/ProductsPage";
import { RoadmapPage } from "../features/roadmap/RoadmapPage";
import { AccessDeniedPage } from "./AccessDeniedPage";
import { AppLayout } from "./AppLayout";
import { LoadingScreen } from "./LoadingScreen";
import { NotFoundPage } from "./NotFoundPage";
import { RequireRole } from "./RequireRole";
import {
  ADMIN_ROLES,
  ARCHIVE_ROLES,
  AUDIT_ROLES,
  DATA_QUALITY_ROLES,
  DECKS_ROLES,
  IMPORT_ROLES,
  PRODUCTS_ROLES,
  PROJECTS_NEW_ROLES,
  PROJECTS_ROLES,
  ROADMAP_ROLES,
} from "./screenAccess";
import { SignInScreen } from "./SignInScreen";

export function App() {
  const { status } = useAuth();

  if (status === "initializing") {
    return <LoadingScreen />;
  }

  if (status === "unauthenticated") {
    return <SignInScreen />;
  }

  return (
    <Routes>
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/roadmap" replace />} />
        <Route
          path="/roadmap"
          element={
            <RequireRole roles={ROADMAP_ROLES}>
              <RoadmapPage />
            </RequireRole>
          }
        />
        <Route
          path="/projects"
          element={
            <RequireRole roles={PROJECTS_ROLES}>
              <ProjectsPage />
            </RequireRole>
          }
        />
        <Route
          path="/projects/new"
          element={
            <RequireRole roles={PROJECTS_NEW_ROLES}>
              <ProjectDetailPage />
            </RequireRole>
          }
        />
        <Route
          path="/projects/:projectKey"
          element={
            <RequireRole roles={PROJECTS_ROLES}>
              <ProjectDetailPage />
            </RequireRole>
          }
        />
        <Route
          path="/products"
          element={
            <RequireRole roles={PRODUCTS_ROLES}>
              <ProductsPage />
            </RequireRole>
          }
        />
        <Route
          path="/data-quality"
          element={
            <RequireRole roles={DATA_QUALITY_ROLES}>
              <DataQualityPage />
            </RequireRole>
          }
        />
        <Route
          path="/decks"
          element={
            <RequireRole roles={DECKS_ROLES}>
              <DecksPage />
            </RequireRole>
          }
        />
        <Route
          path="/archive"
          element={
            <RequireRole roles={ARCHIVE_ROLES}>
              <ArchivePage />
            </RequireRole>
          }
        />
        <Route
          path="/import"
          element={
            <RequireRole roles={IMPORT_ROLES}>
              <ImportPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireRole roles={ADMIN_ROLES}>
              <AdminPage />
            </RequireRole>
          }
        />
        <Route
          path="/audit"
          element={
            <RequireRole roles={AUDIT_ROLES}>
              <AuditPage />
            </RequireRole>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
